<template>
  <div class="list-section">
    <!-- 搜索区域 -->
    <div class="search-bg">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item :label="$t('proxy.text88') + '：'" class="search-label">
            <el-input
              v-model="filters.customerName"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="agentConfig.phoneLoginReg">
          <el-form-item
            :label="$t('followOrder.text6') + '：'"
            class="search-label"
          >
            <el-input
              v-model="filters.phone"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="agentConfig.emailLoginReg">
          <el-form-item :label="$t('proxy.text34') + '：'" class="search-label">
            <el-input
              v-model="filters.email"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text7') + '：'"
            class="search-label"
          >
            <el-input
              v-model="filters.fundAccountId"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('trade.text116') + '：'"
            class="search-label"
          >
            <el-select v-model="filters.bizType" placeholder="" clearable>
              <el-option
                :label="$t('followOrder.text78')"
                :value="1"
              ></el-option>
              <el-option
                :label="$t('followOrder.text134')"
                :value="3"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二行 -->
      <el-row :gutter="20" style="margin-top: 10px">
        <el-col :span="7">
          <el-form-item
            :label="$t('fundHistory.text8') + '：'"
            class="search-label"
          >
            <el-date-picker
              v-model="filters.timeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              placeholder=""
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            @click="handleSearch"
            class="search-button"
            >{{ $t("proxy.text13") }}</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="list-spacer"></div>

    <!-- 总分成金额 -->
    <div class="overview-container">
      <span class="summary-title"
        >{{ $t("followOrder.text123") + "："
        }}<span class="summary-text">{{ summary.totalAmount }}USD</span></span
      >
    </div>

    <div class="list-spacer"></div>

    <!-- 表格列表 -->
    <div class="table-container">
      <el-table :data="displayedData" style="width: 100%" v-loading="loading">
        <el-table-column
          prop="customerName"
          :label="$t('proxy.text88')"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          prop="phone"
          :label="$t('followOrder.text6')"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          prop="email"
          :label="$t('proxy.text34')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="webAccountName"
          :label="$t('followOrder.text7')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bizTypeDesc"
          :label="$t('trade.text116')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('followOrder.text124')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="separateProfitDesc"
          :label="$t('followOrder.text125')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="time"
          :label="$t('followOrder.text126')"
          align="center"
        ></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import apiService from "@/api/request";

export default {
  setup() {
    const store = useStore();
    const loading = ref(false);
    const agentConfig = computed(() => store.getters.getAgentConfig);

    const filters = reactive({
      customerName: "",
      phone: "",
      fundAccountId: "",
      bizType: "",
      timeRange: [],
      email: "",
    });

    const displayedData = ref([]);
    const summary = reactive({
      totalAmount: 0,
    });

    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0,
    });

    const fetchData = async () => {
      loading.value = true;
      try {
        const params = {
          userToken:
            store.getters.userToken !== "" ? store.getters.userToken : "x",
          page: pagination.currentPage,
          limit: pagination.pageSize,
          customerName: filters.customerName,
          phone: filters.phone,
          email: filters.email,
          fundAccountId: filters.fundAccountId,
          bizType: filters.bizType,
          startTime: filters.timeRange
            ? filters.timeRange.length
              ? filters.timeRange[0]
              : ""
            : "",
          endTime: filters.timeRange
            ? filters.timeRange.length
              ? filters.timeRange[1]
              : ""
            : "",
        };

        const response = await apiService.followProfitList(params);
        const {
          followProfitDetails,
          summary: totalAmount,
          count,
        } = response.data;
        displayedData.value = followProfitDetails;
        summary.totalAmount = totalAmount;
        pagination.total = count;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.currentPage = 1;
      fetchData();
    };

    const handleSizeChange = (val) => {
      pagination.pageSize = val;
      fetchData();
    };

    const handleCurrentChange = (val) => {
      pagination.currentPage = val;
      fetchData();
    };

    onMounted(() => {
      fetchData();
    });

    return {
      filters,
      displayedData,
      summary,
      pagination,
      loading,
      handleSearch,
      handleSizeChange,
      handleCurrentChange,
      agentConfig,
    };
  },
};
</script>

<style lang="less" scoped>
</style>
